var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('b-table',{attrs:{"hover":"","outlined":"","stacked":"xl","items":_vm.items,"fields":_vm.fields}}):_c('p',[_vm._v(_vm._s(_vm.$gettext('No history or event information available.')))])
}
var staticRenderFns = []

export { render, staticRenderFns }